import axios from 'axios';
import i18n from '@/i18n';
import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';
import H_file from '@/helpers/file';

export default{
  async importFile(url, file) {
    const formData = new FormData();
    formData.append("file", file);
    const postUrl = url;
    try {
      const res = await axios.post(postUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (error) {
      alert(i18n.t(error));
    }
  },
  async getFolder(id, cancelTokenSource) {
    const res = await base.show({
      modelName: 'file_folder',
      modelId: id,
      cancelTokenSource,
    });
    return res;
  },
  async getFile(id) {
    const res = await base.show({
      modelName: 'file',
      modelId: id,
    });
    return res;
  },
  async createFolder(data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      modelName: 'file_folder',
      data: _data,
    });
    return res;
  },
  async updateFolder(id, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'file_folder',
      modelId: id,
      data: _data,
    });
    return res;
  },
  async updatePathFolder(id, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'file_folder',
      parentId: id,
      modelName: 'update/path',
      data: _data,
    });
    return res;
  },
  async updatePathFile(id, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'file',
      parentId: id,
      modelName: 'update/path',
      data: _data,
    });
    return res;
  },
  async deleteFolder(id) {
    const params = {
      factory: store.state.app.factory.id,
    };
    try {
      const res = await axios.delete(`file_folder/${id}`, {params});
      return res;
    } catch (err) {
      return err.response.data.message;
    }
  },
  async deleteFile(id, module) {
    const params = {
      factory: store.state.app.factory.id,
    };
    if (module) params.module = module;
    const res = await base.delete({
      modelName: 'file',
      modelId: id,
      params: params,
    });
    return res;
  },
  async updateRemark(id, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      parentName: 'file',
      parentId: id,
      modelName: 'update/remark',
      data: _data,
    });
    return res;
  },
  async updateFile(id, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'file',
      modelId: id,
      data: _data,
    });
    return res;
  },
  async download(url, fileName, fileType, versionNumber) {
    store.dispatch('downloadPopup/open');
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('download failed');
      const blob = await response.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      const hasExtension = fileName.toLowerCase().endsWith(`.${fileType.toLowerCase()}`);
      const baseName = hasExtension ? fileName.slice(0, -`.${fileType}`.length) : fileName;
      const versionSuffix = versionNumber ? ` ver ${versionNumber}` : '';
      a.setAttribute('download', `${baseName}${versionSuffix}.${fileType}`);
      a.click();
      store.dispatch('downloadPopup/close');
    } catch (error) {
      base.setErrorMessage(error);
      store.dispatch('downloadPopup/showError', '下載失敗，請稍後再試');
      throw error;
    }
  },
  async getActivity(activityId) {
    const res = await base.show({
      modelName: 'file_log',
      modelId: activityId,
    });
    return res;
  },
  async checkDeleteScope(fileId, module) {
    const res = await axios.get(`file/${fileId}/check/delete`, {
      params: {
        factory: store.state.app.factoryId,
        module,
      },
    });
    return res.data.message;
  },
  async getUserScope(folderId, cancelTokenSource) {
    const res = await base.show({
      url: `file_folder/${folderId}/user/scope`,
      cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
    });
    return res;
  },
  async deleteSystemFileList(rawFileList, uploadModule) {
    const systemFile = rawFileList.filter(file => file.isSystem);
    if (systemFile.length) {
      const allTask = systemFile.map(file => this.deleteFile(file.id , uploadModule));
      await Promise.all(allTask);
    }
  },
  async getFileFromOtherUnits(id) {
    const res = await base.show({
      modelName: 'file/share',
      modelId: id,
    });
    return res;
  },
  async getWordFields(versionId) {
    const res = await base.show({
      modelName: 'file_version/word_fields',
      modelId: versionId,
    });
    return res;
  },
  async getExcelFields(versionId) {
    const res = await base.show({
      modelName: 'file_version/xlsx_fields',
      modelId: versionId,
    });
    return res;
  },
  async storeWithUploadV2(fileName, data) {
    const removeSpecialCharactersFileName = H_file.removeSpecialCharacters(fileName);
    const res = await base.create({
      url: `v2/file/store_with_upload/${removeSpecialCharactersFileName}`,
      data,
    });
    return res;
  },
  async versionStoreWithUpload(fileId, fileName, data) {
    const removeSpecialCharactersFileName = H_file.removeSpecialCharacters(fileName);
    const res = await base.create({
      url: `file/${fileId}/file_version/store_with_upload/${removeSpecialCharactersFileName}`,
      data,
    });
    return res;
  },
  async storeSystemFile(fileName, data) {
    const removeSpecialCharactersFileName = H_file.removeSpecialCharacters(fileName);
    const res = await base.create({
      url: `file/store_system_file/${removeSpecialCharactersFileName}`,
      data,
    });
    return res;
  },
}
